import { Component, OnDestroy, OnInit, Self, input, output } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { faClose, faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { ReplaySubject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-search-input',
  templateUrl: 'input-search.component.html',
  styleUrls: ['input-search.component.scss']
})
export class InputSearchComponent implements OnInit, OnDestroy, ControlValueAccessor {
  debounce = input<number>(500);
  iconColor = input<UiPalette>('primary');
  placeholder = input<string>();
  testId = input<string>();

  keyupEnter = output<void>();

  onChange: (value: string) => void;
  onTouched: () => void;

  currentValue: string;
  faClose = faClose;
  faMagnifyingGlass = faMagnifyingGlass;

  private input$ = new ReplaySubject(1);
  private subscriptions: Subscription[] = [];

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.input$.pipe(debounceTime(this.debounce())).subscribe((value: string) => {
        this.onTouched();
        this.onChange(value);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    this.currentValue = value ?? '';
    this.input$.next(value ?? '');
  }

  setValue($event: any): void {
    this.currentValue = $event.target.value;
    this.input$.next($event.target.value);
  }

  clearValue(): void {
    this.currentValue = '';
    this.input$.next('');
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if needed
  }
}
